/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export const FINISH_UPLOAD_MUTATION = `
  mutation FINISH_UPLOAD_MUTATION($input: finishUploadInput!) {
    finishUpload(input: $input) {
      success
      key
      message
    }
  }
`;